// TODO: remove after client regeneration replaces the interim api-v2 services.
import { AuthControllerService } from 'src/app/api-client';

/**
 * Resolves the REST API base path exactly the way the generated api-client resolves
 * it (the BASE_PATH injection token when provided, otherwise the generation-time
 * default baked into the generated services), so the interim v2 services always hit
 * the same backend as the rest of the app.
 *
 * NOTE: `environment.url` is the static/image host (used app-wide as `backendUrl`),
 * NOT the API base — it must not be used here, or the v2 calls end up pointed at a
 * different backend than the one the user authenticated against (causing spurious 401s).
 */
export function resolveApiBasePath(apiConfig: AuthControllerService): string {
  return (apiConfig.configuration.basePath ?? '').replace(/\/+$/, '');
}
